import { connect } from 'react-redux';

import { selectActiveVersions } from 'app/developer-v3/store/selectors';
import { sortVersionStrings } from 'app/developer-v3/utils';

import HistoryPage from './HistoryPage';

const mapStateToProps = state => {
  return {
    versions: sortVersionStrings(selectActiveVersions(state)),
  };
};

export default connect(mapStateToProps)(HistoryPage);
